import { __ } from '@wordpress/i18n';

import {
	CheckboxControl,
	__experimentalVStack as VStack,
} from '@wordpress/components';

export function Devices( props ) {
	const { onChangeDevice, rules, activeTab } = props;

	const devicesArr = rules[ activeTab ];

	const onChange = ( val, device ) => {
		let filteredArray = devicesArr;
		if ( val ) {
			filteredArray = [ ...devicesArr, device ];
		} else {
			filteredArray = devicesArr.filter( ( item ) => item !== device );
		}
		onChangeDevice( filteredArray );
	};

	return (
		<VStack>
			<CheckboxControl
				label={ __( 'Desktop', 'popper' ) }
				id="popper-desktop"
				checked={ devicesArr.includes( 'desktop' ) }
				onChange={ ( val ) => onChange( val, 'desktop' ) }
				__nextHasNoMarginBottom
			/>
			<CheckboxControl
				label={ __( 'Tablet', 'popper' ) }
				id="popper-tablet"
				checked={ devicesArr.includes( 'tablet' ) }
				onChange={ ( val ) => onChange( val, 'tablet' ) }
				__nextHasNoMarginBottom
			/>
			<CheckboxControl
				label={ __( 'Mobile', 'popper' ) }
				id="popper-mobile"
				checked={ devicesArr.includes( 'mobile' ) }
				onChange={ ( val ) => onChange( val, 'mobile' ) }
				__nextHasNoMarginBottom
			/>
		</VStack>
	);
}
